// Live chat - Footer button
//
// Shopify Inbox now ships as a storefront web component: a <shopify-chat>
// (or <shopify-agent>) element at the end of <body>, with the launcher
// button exposed as ::part(activator). That launcher is hidden in
// krovel.css.liquid, so this footer button is the only way in.
//
// The old markup (#shopify-chat > inbox-online-store-chat, toggled by
// clicking .chat-toggle inside its shadow root) is still served to some
// shops by the Inbox bundle selector, so it is kept as a fallback.
(function () {
  const TRIGGER_SELECTOR = ".closechatcustom";
  const CHAT_SELECTOR = "shopify-chat, shopify-agent";
  const LEGACY_WRAPPER = "#shopify-chat";

  function openLegacyChat() {
    const wrapper = document.querySelector(LEGACY_WRAPPER);
    const hostElement = wrapper?.querySelector("inbox-online-store-chat");
    if (!hostElement) return;

    wrapper.style.visibility = "visible";
    hostElement.shadowRoot?.querySelector(".chat-toggle")?.click();
  }

  function openChat() {
    const chat = document.querySelector(CHAT_SELECTOR);
    if (!chat) {
      openLegacyChat();
      return;
    }

    if (typeof chat.show === "function") {
      chat.show();
      return;
    }

    // The Inbox bundle is still loading, so the element has not been
    // upgraded yet and has no show() on it. Wait for it, then open.
    customElements.whenDefined(chat.localName).then(function () {
      customElements.upgrade(chat);
      if (typeof chat.show === "function") {
        chat.show();
      } else {
        chat.setAttribute("open", "");
      }
    });
  }

  // Delegated so the button works no matter when it is rendered.
  document.addEventListener("click", function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest(TRIGGER_SELECTOR)) return;

    event.preventDefault();
    openChat();
  });
})();
